import { render, staticRenderFns } from "./BuildingDetailView.vue?vue&type=template&id=5ec5cae0&scoped=true"
import script from "./BuildingDetailView.vue?vue&type=script&lang=js"
export * from "./BuildingDetailView.vue?vue&type=script&lang=js"
import style0 from "./BuildingDetailView.vue?vue&type=style&index=0&id=5ec5cae0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec5cae0",
  null
  
)

export default component.exports